import {useTranslation} from 'react-i18next';

import './PolicyHeader.scss';
import {PickSiteLanguage} from 'src/components/main/components/PickSiteLanguage';

export function PolicyHeader() {
    const {t} = useTranslation();

    return (
        <header className='policy-header-nav'>
            <div className='policy-header-nav__flex'>
                <img className='logo' src='/mittvaccin_logo.svg' alt={t('logo_alt.text')} />

                <PickSiteLanguage />
            </div>
        </header>
    );
}
